import React from "react";
import { MessageCircle, Phone, Mail } from "lucide-react";
import SupportChannelCard from "./SupportChannelCard";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const SupportChannels = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const channelsData =
    labels.menuPages?.buyCar?.customerServiceSection?.supportChannels || [];

  const icons = [
    <MessageCircle className="w-8 h-8" />,
    <Phone className="w-8 h-8" />,
    <Mail className="w-8 h-8" />,
  ];
  const colors = [
    "from-green-500 to-emerald-500",
    "from-blue-500 to-cyan-500",
    "from-purple-500 to-pink-500",
  ];

  const supportChannels = channelsData.map((channel: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: channel.title || "",
    description: channel.description || "",
    availability: channel.availability || "",
    response: channel.response || "",
    color: colors[index] || colors[0],
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
      {supportChannels.map((channel, index) => (
        <SupportChannelCard key={index} channel={channel} index={index} />
      ))}
    </div>
  );
};

export default SupportChannels;
